module.exports = __webpack_public_path__ + "media/images/load_anime-f8d2e726bae8582fc5a3386a9505b699.gif";